import axiosInstance from "../config/axiosInstance";
import { API_ENDPOINTS } from "../constants/apiEndpoints";
import { normalizeUploadedImageUrl } from "./uploadImage";

export const getTypicalProjectInformationItemsByLanguage = async (
  languageCode,
  typicalProjectId,
) => {
  if (!typicalProjectId) return [];

  const response = await axiosInstance.get(
    API_ENDPOINTS.TYPICAL_PROJECT_INFORMATION_ITEMS.GET_BY_LANGUAGE(
      languageCode,
      typicalProjectId,
    ),
  );
  const rawData = response.data;
  let data = rawData;

  if (typeof rawData === "string") {
    try {
      data = JSON.parse(rawData);
    } catch {
      data = [];
    }
  }
  const result = data?.success && Array.isArray(data.data)
    ? data.data
    : Array.isArray(data)
      ? data
      : Array.isArray(data?.data)
        ? data.data
        : [];

  return result
    .map((item) => ({
      ...item,
      iconURL: normalizeUploadedImageUrl(
        item.iconURL || item.iconUrl || item.icon || "",
      ),
    }))
    .sort((a, b) => (Number(a.sortOrder) || 0) - (Number(b.sortOrder) || 0));
};
